import uniqBy from 'lodash/uniqBy';

/**
 * It is possible that that there are duplicates of a notifications,
 * because the notifications are retrieved from multiple data sources.
 * @param {object || array} newNotifications - can be one (object) or multiple (array) notifications
 * @param {array} currentNotifications
 *
 */
const getUniqueNotifications = (newNotifications, currentNotifications) => {
  let mergedData = [];
  if (Array.isArray(newNotifications)) {
    mergedData = [...newNotifications, ...currentNotifications];
  } else if (
    typeof newNotifications === 'object' &&
    newNotifications !== null
  ) {
    mergedData = [newNotifications, ...currentNotifications];
  }
  const uniqueArray = uniqBy(mergedData, 'slug');

  return uniqueArray;
};

export default getUniqueNotifications;
